import {
  useQuery,
  UseQueryResult,
} from '@tanstack/react-query';
import {
  getPatients,
} from 'pages/Dashboard/services/api';
import {
  PaginatedPatientList,
} from 'pages/Dashboard/types/patient';
import {
  notEmptyString,
} from '@populateui/utils';

export default function useSearchPatients(
  searchQuery: string,
  page: number,
  pageSize: number,
  enabled = true,
): UseQueryResult<PaginatedPatientList, Error> {
  const queryResult = useQuery<PaginatedPatientList, Error>({
    queryKey: ['patients', searchQuery],
    queryFn: () => getPatients({
      search: searchQuery?.trim() ?? '',
      page,
      pageSize,
    }),
    enabled: enabled && notEmptyString(searchQuery),
  });

  return queryResult;
}
